// https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
export default function sanitizeS3FileName(fileName) {
    return fileName.replace(/[^0-9a-z-._*/!'/(/)]/gi, '')
}